<template>
	<div class="content">
		<div class="content-con">
			<div class="logo">
				<img src="../assets/logo(1).png">
			</div>
			<div class="banner">
				<img src="../assets/queryBanner.png">
			</div>
			<div class="show-content">
				<div class="con1" v-if="show==1">
					<div class="con-title">国家顶级节点标识</div>
					<div class="con-de">
						    标识解析国家顶级节点是一个国家或者地区内部最顶级的标识解析服务节点。</br>    能够面向全国范围提供顶级标识编码注册和标识解析服务，以及标识备案、标识认证等管理能力。
					</div>
				</div>
				<div class="con2" v-if="show==2">
					<div class="con-title">国家顶级节点标识解析服务</div>
					<div class="con-de">
							根节点：</br>  全球有多个根结点，每一个根多节点都是独立、平等的。根节点是标识管理体系中最高等级的国际性标识服务节点，提供面向全球范围或者若干国家/地区的公共的根级别的标识服务。
					</div>
					<div class="notice-conten3" >
						<div v-for="(item,index) in contentList" :key="index">
							<div class="title">{{item.title}}</div>
							<div class="cont">{{item.cont}}</div>
						</div>
					</div>
				</div>
				<div class="con3" v-if="show==3">
					<div class="con-title">企业官媒标识服务节点建设内容</div>
					<div class="con-de">
							    在工业信息化部信息通信研究院指导下，达成战略合作，企媒号科技作为国家顶级节点标识平台的注册服务机构，成为国家顶级节点标识平台建设力量的有力构成，承担或参与到工业互联网标识解析服务节点的应用软件平台研发、及全国标识应用系统服务节点的部署、联合运营等工作中。企媒号科技在工业互联网标识解析体系，标识服务节点建设、应用系统导入、业务规划和运营等方面具备全生命周期服务能力。
					</div>
				</div>
				<div class="con4" v-if="show==4">
					<div class="con-title">企业官媒应用标识服务</div>
					<div class="con-de">
							        标识是“物”的身份。也是官媒标识的身份证 ， 在万物互联的智能世界里，“官媒标识“不仅包括实体对象，如企业名称（简称），产品，项目，设备，品牌（名称+LOGO）以及注册信息/服务期限等，获得的国家顶级节点标识编码，录入国家顶级节点标识数据库，把它们统称为”数字对象“官媒标识的身份由一套统一的体系来发放和管理，所以能够相互识别，实现互通。</br>    官媒标识拥有身份才能互通识别，通过互联互通分发传播，才能够相互可连接，相互信任，相互操作。
					</div>
				</div>
				
				
			</div>
		</div>
		<Bottom />
	</div>
</template>

<script>
	import Bottom from "../components/bottom.vue"
	export default{
		name:'showContent',
		components:{
			Bottom
		},
		data(){
			return{
				show:1,
				contentList:[
					{
						title:'国家顶级节点',
						cont:'是一个国家或地区内部最顶级的标识服务节点，能够面向全国/全区范围提供标识注册分配、标识解析审核认证及数据托管等服务，并为行业节点和企业节点提供查询指引国家顶级节点向上与支持各类标识体系的国际根节点保持连通，向下与国内/区内各行业（或企业）二级节点保持连通。'
					},
					{
						title:'二级节点',
						cont:'是面向特定行业平台、通用性平台或大型企业平台提供标识服务的公共节点，可以根据行业具体需求定义灵活的行业性标识数据格式。二级节点向上连接国家顶级节点，向下为工业企业分配标识资源、提供标识注册、解析、公共查询等数据服务，同时满足稳定性、安全性和可扩展性等多方面的要求。二级节点是推动工业互联网标识产业规模化发展和应用的重要抓手，对于树立有价值的行业标识应用标杆、开创可持续发展的业务模式至关重要。'
					},
					{
						title:'企业节点',
						cont:'是面向工业企业内部的标识服务节点可以面向特定企业提供标识内部注册分配和标识解析服务，可以独立部署也可以作为企业信息系统的一部分。根据企业规模可以灵活定义企业内标识解析系统组网形式以及企业内部标识数据格式。企业节点的标识编码与标识解析服务不限定技术方案可与国家顶级节点实现不同标识解析体系之间的互联互通。'
					},
					{
						title:'公共递归节点',
						cont:'是标识解析体系的关键入口设施，代替用户进行复杂的迭代查询。利用缓存技术，也可以将查询结果直接返回给用户，提升整体解析服务性能。当收到客户端的标识解析请求时，公共递归节点首先会在本地缓存进行查询，如果没有命中查询结果，则会查询标识解析服务器，按照其返回的应答查询路径进行查询，直至查询到标识对应的地址和关联信息，将其返回给用户并将查询响应结果进行缓存。'
					}
				],
				
			}
			
		},
		mounted() {
			console.log(this.$route.query)
			if(this.$route.query.type){
				this.show=this.$route.query.type
			}
		}
	}
</script>

<style>
	body
	{
		background: #ffffff;
	}
	img
	{
		display: block;
	}
	a
	{
		text-decoration: none;
	}
	.content
	{
		background: #ffffff;
	}
	.content-con
	{
		width: 100%;
		max-width:1920px;
		margin: auto;
	}
	.logo
	{
		margin-top: 10px;
	}
	.logo img
	{
		height: 60px;
	}
	.banner
	{
		/* margin-top: 13px; */
	}
	.banner img
	{
		width: 100%;
	}
	.show-content
	{
		width: 1200px;
		min-height: 360px;
		margin: auto;
		margin-top: 40px;
		margin-bottom: 30px;
		background: #f5f5f5;
		padding: 20px 20px 40px 20px;
	}
	.show-content .con-title
	{
		text-align:center;
		font-size: 26px;
		font-weight: bold;
	}
	.show-content .con-de
	{
		font-size:20px;
		line-height:36px;
		margin-top:30px !important;
	}
	.show-content .con1 .con-de
	{
		width: 600px;
		margin: auto;
	}
	.show-content .con2 .con-de,.show-content .con3 .con-de
	{
		width: 700px;
		margin: auto;
	}
	.show-content .con4 .con-de
	{
		width: 700px;
		margin: auto;
	}
	.notice-title
	{
		font-size: 35px;
		color: #444444;
		text-align: center;
	}
	.notice-conten3
	{
		background: #f5f5f5;
		padding-top: 20px;
		box-sizing: border-box;
		margin-top: 20px;
		display: flex;
	}
	.notice-conten3>div
	{
		flex: 1;
		/* padding: 0 10px; */
	}
	.notice-conten3>div .title
	{
		width: 160px;
		height: 60px;
		line-height: 60px;
		background: #ffffff;
		
		margin: auto;
		margin-bottom: 12px;
		font-size: 24px;
		font-weight: bold;
		text-align: center;
	}
	.notice-conten3>div .cont
	{
		/* background: #ffffff; */
		font-size: 18px;
		height: 380px;
		line-height: 28px;
		padding: 5px 12px;
		padding-bottom: 20px;
	}
	@media screen and (max-width: 640px){
		.content-con
		{
			width: 100%;
			max-width:100%;
			margin: auto;
		}
		.logo
		{
			padding: 0 2vw;
			margin-top: 10px;
		}
		.logo img
		{
			width: 100%;
			height: auto;
		}
		.banner
		{
			margin-top: 2vw;
		}
		.banner img
		{
			width: 100%;
		}
		.show-content
		{
			width: 100%;
			min-height: auto;
			margin: auto;
			margin-top: 3vw;
			margin-bottom: 3vw;
			background: #f5f5f5;
			padding: 3vw;
		}
		.show-content .con-title
		{
			text-align:center;
			font-size: 24px;
			font-weight: bold;
		}
		.show-content .con-de
		{
			font-size:18px;
			line-height:30px;
			margin-top: 3vw !important;
		}
		.show-content .con1 .con-de
		{
			width: 100%;
			margin: auto;
		}
		.show-content .con2 .con-de,.show-content .con3 .con-de
		{
			width: 100%;
			margin: auto;
		}
		.show-content .con4 .con-de
		{
			width: 100%;
			margin: auto;
		}
		.notice-title
		{
			font-size: 24px;
			color: #444444;
			text-align: center;
		}
		.notice-conten3
		{
			background: #f5f5f5;
			padding-top: 3vw;
			box-sizing: border-box;
			margin-top: 3vw;
			display: block;
		}
		.notice-conten3>div
		{
			width: 100%;
			/* padding: 0 10px; */
		}
		.notice-conten3>div .title
		{
			width: 160px;
			height: 60px;
			line-height: 60px;
			background: #ffffff;
			
			margin: auto;
			margin-bottom: 12px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}
		.notice-conten3>div .cont
		{
			/* background: #ffffff; */
			font-size: 18px;
			height: auto;
			margin-top: 3vw;
			line-height: 28px;
			padding: 2vw 3vw;
			padding-bottom: 20px;
		}
	}
</style>
